module.exports = __webpack_public_path__ + "93f8f99754952cece4f59d2a7369100c.fbx";